import React from 'react';
import {_GPY,__GPYPost} from '../../../env.js'

import moment from 'moment';
import 'moment/locale/de';
import OBS from '../../OBS.js'

class ScoreboardGameSelector extends  React.Component {

	constructor(props) {
		super(props);
		this.state = {
					doStore: false,
					keyConfMode:false,
					timeConfMode:false,
		};
	}

  render () {
    return (<div>

      {this.props.beta?
        <><span className="text-danger"><span className="glyphicon glyphicon-wrench" aria-hidden="true"></span> Beta Version</span><button className="btn btn-link btn-sm" onClick={()=>{ this.props.scoreboard.props.setGameType("BugReport")}}>Report bugs or wishes</button></>:""}

      <div className="row justify-content-end">
        <div className="col-6 text-left">


					<button type="button" onClick={()=>{this.props.scoreboard.doChangeValue({},"OBS","toggleOBSPanel");}} className={this.props.scoreboard.state.components.OBS!==undefined&&this.props.scoreboard.state.components.OBS.state.showOBSPanel===true?"btn btn-sm btn-warning":"btn btn-sm btn-outline-secondary"}><img style={{verticalAlign: "baseline", maxWidth : '13px', maxHeight : '13px'}} src={_GPY.resource("images/obs_black.png")} className="img-fluid" alt=""/></button>

		<div className="btn-group pl-1" role="group" aria-label="menuicons">
				  <button type="button" onClick={()=>{
						var tmp = !this.state.keyConfMode;
						this.setState({keyConfMode:tmp,timeConfMode:false,doStore:tmp},()=>{
							var tbs = this.props.scoreboard.state.toggleButtons;
							Object.keys(tbs).forEach((key, i) => {
								  tbs[key].toggleKeyCodeEditMode(this.state.keyConfMode);
							});
						});
					}} className={this.state.keyConfMode?"btn btn-sm btn-warning":"btn btn-sm btn-outline-secondary"}><span className="glyphicon glyphicon-cog" aria-hidden="true"></span></button>

					<button type="button" onClick={()=>{
						var tmp = !this.state.timeConfMode;
						this.setState({timeConfMode:tmp,keyConfMode:false,doStore:tmp},()=>{
							var tbs = this.props.scoreboard.state.toggleButtons;
							Object.keys(tbs).forEach((key, i) => {
								  tbs[key].toggleAutoexpirytimeEditMode(this.state.timeConfMode);
							});
						});
					}} className={this.state.timeConfMode?"btn btn-sm btn-warning":"btn btn-sm btn-outline-secondary"}><span className="glyphicon glyphicon-time" aria-hidden="true"></span></button>
    </div>

{_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?
		<div className="btn-group pl-1" role="group" aria-label="adminmenuicons">
				<button type="button" onClick={()=>{
					var tbs = this.props.scoreboard.state.toggleButtons;
					var list = [];
					Object.keys(tbs).forEach((key, i) => {
							list.push(key);
					});
					list.sort();
					_GPY.toggleButtonList = list;
					console.log("toggleButtonList",	_GPY.toggleButtonList);
				}} className="btn btn-sm btn-outline-secondary"><span className="glyphicon glyphicon-copy" aria-hidden="true"></span></button>
  	</div>
:""}

{this.state.doStore?
	<div className="btn-group pl-2" role="group" aria-label="discardorstore">
					<button type="button" onClick={()=>{
						var tbs = this.props.scoreboard.state.toggleButtons;
						var conf = {};
						Object.keys(tbs).forEach((key, i) => {
								tbs[key].disableEditMode();
								console.log(key,tbs[key]);

								conf[key] = tbs[key].getConfig();
								console.log(conf[key]);
						});

						this.props.scoreboard.storeUserConfig("buttons_",conf,()=>this.setState({doStore:false,timeConfMode:false,keyConfMode:false}));
					}} className="btn btn-sm btn-success"><span className="glyphicon glyphicon-save" aria-hidden="true"></span> Store</button>

					<button type="button" onClick={()=>{
							var tbs = this.props.scoreboard.state.toggleButtons;
							Object.keys(tbs).forEach((key, i) => {
								tbs[key].disableEditMode();
							});
						  this.props.scoreboard.loadUserConfig().then((res)=>{
								this.setState({doStore:false,timeConfMode:false,keyConfMode:false});
							});
					}} className="btn btn-sm btn-secondary"><span className="glyphicon glyphicon-ban-circle" aria-hidden="true"></span> Discard changes</button>
	</div>
	:""}

        </div>
        <div className="col-6 text-right"><button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target={"#gametype_"+this.props.scoreboard.getName()+"_scoreboard_games"} aria-expanded="false" aria-controls={"gametype_"+this.props.scoreboard.getName()+"_scoreboard_games"}>
        <span className="text-secondary">
        <span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>&nbsp;
        {this.props.scoreboard.state.currentGame.id > 0 ? this.props.scoreboard.state.currentGame.gameName + " - " + moment(this.props.scoreboard.state.currentGame.startTime).locale('de').format('L') + " (" + moment(this.props.scoreboard.state.currentGame.startTime).locale(_GPY.locale).format('HH:mm') + "-"+  moment(this.props.scoreboard.state.currentGame.endTime).locale(_GPY.locale).format('HH:mm')+ ")":_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_select_game_title')}
        &nbsp;<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>
        </span>
        </button>
        </div>
      </div>


      <div className="collapse bg-light" id={"gametype_"+this.props.scoreboard.getName()+"_scoreboard_games"}>
      						<div className="row justify-content-center pt-4">
      								{this.props.scoreboard.state.gamesIsLoaded && this.props.scoreboard.state.games.Games.Game.length>0?
      									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_select_game_title')}</h3></div>
      								:
      									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_select_nogame_title')}</h3></div>
      								}
      								<div className="col-12 col-sm-12 col-md-8 col-xl-8">
      									<div className="list-group">
      										 {this.props.scoreboard.state.gamesIsLoaded ? this.props.scoreboard.state.games.Games.Game.map((t) => {
      											 if( (_GPY.toLocaleMoment(t.endTime) + (1000*60*60)) > _GPY.toLocaleMoment(moment()) )  {
      												return (
      												<button key={t.id} onClick={()=> { this.props.scoreboard.onSelectGame(t.id,this.props.scoreboard.reset())}} className={t.id === this.props.scoreboard.state.currentGame.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
      													<div className="row p-2">
      													<div className="col-12 text-center"><span>{t.gameName} - {moment(t.startTime).locale('de').format('L')}  ({moment(t.startTime).locale(_GPY.locale).format('HH:mm')} - {moment(t.endTime).locale(_GPY.locale).format('HH:mm')})</span></div>
      													</div>
      												</button>);
      											} else {
      												return "";
      											}

      										 })  : "" }
      									</div>
      								</div>
      						</div>

      						<div className="row p-4">
      							<div className="col border-top"></div>
      							<div className="col-1 text-center text-muted"><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/></div>
      							<div className="col border-top"></div>
      						</div>

      </div>

      <OBS className="mb-2" scoreboard={this.props.scoreboard}/>


      </div>)
  }
}
export default ScoreboardGameSelector;
